var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleAngle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3599 2.39999C3.86986 2.39999 4.2867 2.79763 4.31779 3.29976L4.56014 3.5421C4.84131 3.82328 4.84131 4.27905 4.56014 4.56023C4.48927 4.63109 4.40733 4.68404 4.3199 4.71913V13.2H10.0799C10.4775 13.2 10.7999 13.5223 10.7999 13.92V19.68H19.2808C19.3159 19.5926 19.3688 19.5106 19.4397 19.4398C19.7208 19.1586 20.1766 19.1586 20.4578 19.4398L20.6999 19.6819C21.2021 19.7128 21.5999 20.13 21.5999 20.64C21.5999 21.1702 21.1701 21.6 20.6399 21.6H3.3599C2.82971 21.6 2.3999 21.1702 2.3999 20.64V3.35999C2.3999 2.8298 2.82971 2.39999 3.3599 2.39999ZM4.3199 19.68H9.3599V14.64H4.3199V19.68Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9836 15.9837C16.2648 15.7025 16.7208 15.7025 17.0019 15.9837L18.3843 17.366C18.6655 17.6472 18.6655 18.1032 18.3843 18.3844C18.1031 18.6655 17.6471 18.6655 17.3659 18.3844L15.9836 17.002C15.7024 16.7208 15.7024 16.2648 15.9836 15.9837Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5275 12.5276C12.8086 12.2464 13.2647 12.2464 13.5458 12.5276L14.9282 13.9102C15.2093 14.1913 15.2094 14.6471 14.9282 14.9283C14.647 15.2094 14.1912 15.2094 13.9101 14.9283L12.5275 13.5459C12.2463 13.2648 12.2463 12.8087 12.5275 12.5276Z",
    fill: "#464646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07162 9.07171C9.35279 8.79054 9.80857 8.79055 10.0897 9.07171L11.4723 10.4541C11.7535 10.7352 11.7535 11.1913 11.4723 11.4724C11.1912 11.7536 10.7351 11.7536 10.454 11.4724L9.07162 10.0898C8.79046 9.80866 8.79045 9.35288 9.07162 9.07171Z",
    fill: "#464646"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61553 5.61562C5.89671 5.33444 6.35271 5.33444 6.63389 5.61562L8.01623 6.99796C8.29741 7.27914 8.29741 7.73514 8.01623 8.01632C7.73505 8.2975 7.27905 8.2975 6.99787 8.01632L5.61553 6.63398C5.33435 6.3528 5.33435 5.8968 5.61553 5.61562Z",
    fill: "#464646"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleAngle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/triangle_angle.aebf072c6381897f0a566a8c0daeff90.svg";